module.exports = __webpack_public_path__ + "img/mailbox-placeholder.850eae93.svg";